<script>
import TheHero from '@/components/HomePage/HeroFloat.vue'
import HowTherapyUnfolds from '@/components/HomePage/HowTherapyUnfolds.vue'
import RealWorldCaseloads from '@/components/HomePage/RealWorldCaseloads.vue'
import RealWorldCare from '@/components/HomePage/RealWorldCare.vue'
import PlatformStatement from '@/components/HomePage/PlatformStatement.vue'
import CallToAction from '@/components/HomePage/CallToAction.vue'
import VisionTherapyExperts from '@/components/HomePage/VisionTherapyExperts.vue'
export default {
  name: "HomePage",
  components: {
    TheHero,
    HowTherapyUnfolds,
    RealWorldCaseloads,
    RealWorldCare,
    // SupportBlocks,
    PlatformStatement,
    CallToAction,
    VisionTherapyExperts
  },
  data () {
    return {
    }
  },
  computed: {
  }
  // mounted () {
  //   this.$store.commit('ovb/SET_IS_HOME_PAGE', true)
  // }
}
</script>

<template>
  <div class="home-page">
    <div class="bg-top">
      <section
          class="hero-section"
      >
        <article class="container mobile-container">
          <div class="section-container">
            <the-hero />
          </div>
        </article>
      </section>
      <section>
        <article class="container mobile-container">
          <div class="section-container">
            <how-therapy-unfolds />
          </div>
        </article>
      </section>
    </div>
    <section
        class="real-world-caseloads-section py-6"
    >
      <article class="container mobile-container">
        <div class="section-container">
          <real-world-caseloads />
        </div>
      </article>
    </section>
    <section class="platform-statement-section py-6">
      <article class="container mobile-container">
        <platform-statement />
      </article>
    </section>
    <div class="bg-3">
      <section class="clinical-arc-section py-6">
        <article class="container mobile-container">
          <real-world-care />
        </article>
      </section>
      <section class="call-to-action-section py-6">
        <article class="container mobile-container">
          <call-to-action />
        </article>
      </section>
      <section class="vision-therapy-experts-section py-6">
        <article class="container mobile-container">
          <vision-therapy-experts />
        </article>
      </section>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .bg-top {
    //background-color: $charcoal;
    //background: radial-gradient(at center bottom,rgba(2, 154, 192, 1) 0%, rgba(47, 47, 48, 1) 100%);
    //background: radial-gradient(at left top,hsl(199, 54%, 28%) 0%, rgba(47, 47, 48, 1) 100%), radial-gradient(at right bottom,hsl(199, 54%, 28%) 0%, rgba(47, 47, 48, 1) 100%);;
    //background: radial-gradient(at center top,#2C434E 0%, #252E33 100%);
    background: radial-gradient(at 0% 0%, transparent 0%, #2A2B2A 100%),
    linear-gradient(181deg, #183E4F 0%, #0F0F0F 100%);
    background-blend-mode: luminosity;
  }
.hero-section {
  display: flex;
  flex-direction: column;
  padding-top: 5rem;
  background: transparent;
  @include tablet {

  }
}
  .bg-2 {
    background: #80A4B3;
  }

  .real-world-caseloads-section {
    background: linear-gradient(#2a2b2a 0%, #2BAEF0 100%);
  }
  .platform-statement-section {
    background: linear-gradient(0deg, #ef4456 0%, #2baef0 70%);
  }
  .call-to-action-section {
    background-color: $watermelon;
  }
  .bg-3 {
    background: #EF4457;
    background: linear-gradient(180deg, #EF4457, #277AA3);
  }
</style>
